import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Button, LoadingIndicator } from "../../../../components/simple";

import { PLATFORMS } from "../platforms";

import styles from "../push-modal.module.scss";

const PostalCodes = ({
  selectedPlatform,
  onDownload
  // audienceType,
  // editAudienceHandler,
  // allowEdit
}) => {
  const platforms = useSelector(state => state.platforms);

  return (
    <>
      <div
        className={` ${styles["fb-signin"]} ${
          selectedPlatform === PLATFORMS.postalCodes
            ? styles["slide-from-right"]
            : ""
        }`}
      >
        <div className={styles["connect-account"]}>Download .csv file</div>
        {/* <div className={styles["platform-logo"]}> */}
        {/*  <img */}
        {/*    src={SVG.SmartClip} */}
        {/*    className={main["platform-icon"]} */}
        {/*    alt="SmartClip" */}
        {/*  /> */}
        {/* </div> */}

        {platforms?.isLoading ? (
          <div
            style={{ marginTop: "32px" }}
            className="mt-4 d-flex justify-content-center"
          >
            <LoadingIndicator />
          </div>
        ) : (
          <div className="mt-2">
            <Button
              type="button"
              className={styles["platform-signin-button"]}
              onClick={() => {
                onDownload();
              }}
            >
              Download CSV
            </Button>
            {/* {audienceType === "audience" && allowEdit && ( */}
            {/*  <Button */}
            {/*    type="button" */}
            {/*    className={`btn btn-secondary ${styles["edit-audience-btn"]}`} */}
            {/*    onClick={editAudienceHandler} */}
            {/*  > */}
            {/*    <span>Edit audience</span> */}
            {/*  </Button> */}
            {/* )} */}
          </div>
        )}
        <div className={styles["platform-description"]}></div>
      </div>
    </>
  );
};

PostalCodes.propTypes = {
  // audienceType: PropTypes.string.isRequired,
  // editAudienceHandler: PropTypes.func.isRequired,
  selectedPlatform: PropTypes.string,
  onDownload: PropTypes.func
  // allowEdit: PropTypes.bool.isRequired
};

PostalCodes.defaultProps = {
  selectedPlatform: "",
  onDownload: () => {}
};

export default PostalCodes;
